<template>

  <t-page>

    <ChecklistDialog @onSubmit="onChecklistDialog"/>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 msg-return-gender-feminine
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  @click="openDialogForm('modal-checklist')"
                  primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-code-label enterprise
                              v-model="form.enterpriseId"/>

          <t-input-code-label inspector
                              v-model="form.inspectorId"/>

          <t-input-search v-model="form.issueDate" enable-range date label="Data Inspecionado"/>

          <t-input-search v-model="form.enableSingleEnvironment" boolean
                          label="Inspeção individual?"/>

          <t-input-code-label v-if="form.enableSingleEnvironment" environment
                              v-model="form.environmentId"/>

          <t-input-search select v-else :options="typeChecklistOptions" v-model="form.typeChecklistId"
                          label="Modelo de Inspeção"/>

          <t-input-search v-model="form.checklistStatusId" v-if="typeChecklistStatusOptions.length > 0"
                          :options="typeChecklistStatusOptions"
                          label="Status Operacional" radio/>

          <t-input-search v-model="form.statusChecklist" :options="StatusChecklistType.list"
                          label="Status Inspeção" radio/>

        </t-content-header-search-default>

      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-column="checklistNumber" link-primary-column="checklistNumber">


        <template #item(qtyEnvironmentResume)="{item}">

          <t-progress-bar-line :progress="item.qtyEnvironmentFinished" :total="item.qtyEnvironmentTotal"
                               :subtitle="item.qtyEnvironmentResume"/>

        </template>

        <template #item(qtyGeneralOccurrencesTotal)="{item}">

            <span class="mr-1 p-1 border" style="border-radius: 3px" v-b-tooltip.hover.ds500
                  title="Apontamentos abertas">
              <b-icon-clipboard-plus class="opacity-6 mr-1"/>
              <span class="text-danger">{{ item.qtyGeneralOccurrencesNew }}</span>
            </span>

          <span class=" p-1 border" style="border-radius: 3px" v-b-tooltip.hover.ds500 title="Apontamentos finalizados">
              <b-icon-clipboard-check class="opacity-6 mr-1"/>
              <span class="text-success">{{ item.qtyGeneralOccurrencesDone }}</span>
          </span>

        </template>

        <template #item(elapsedTimeTotal)="{item}">
          <b-icon-clock class="mr-1"/>
          {{ item.elapsedTimeTotal | minuteOrHour }}
        </template>

        <template #item(quoteCodeLabel)="{item}">
          <b-link v-if="item.quoteCodeLabel !== ''" :to="{path:'/business/quote/'+item.quoteNumber}">
            {{ item.quoteCodeLabel }}
          </b-link>
          <span v-else>-</span>
        </template>

        <template #item(statusChecklist)="{item}">

          <b-badge v-if="item.statusChecklist=== StatusChecklistType.type.PENDING"
                   variant="danger">Pendente
          </b-badge>
          <b-badge v-else-if="item.statusChecklist=== StatusChecklistType.type.FINISHED"
                   variant="success">Finalizada
          </b-badge>

        </template>

        <template #item(qtyGeneralFile)="{item}">

           <span class=" p-1 border" style="border-radius: 3px" v-b-tooltip.hover.ds500
                 title="Qtd. Imagens coletadas nesta inspeção">
              <b-icon-images class="opacity-6 mr-1"/>
              <span>{{ item.qtyGeneralFile }}</span>
          </span>

        </template>


        <template #append-actions="{item}">

          <!--          <b-button
                        v-if="getRenderRule('enableWordReport')"
                        v-b-tooltip.hover.ds500 title="Envio para fila do Word"
                        @click="sendQueueWordReport('checklist',item.checklistId,'Inspeção nº ' + item.checklistNumber)"
                        size="sm" variant="outline">
                      <b-icon-file-word variant="primary"></b-icon-file-word>
                    </b-button>-->

          <b-button
              v-b-tooltip.hover.ds500 title="Geração de Relatório"
              target="_blank"
              @click="openChecklistReport(item.statusChecklist,item.enterpriseId,item.checklistId,item.typeChecklistId,item.checklistNumber,item.businessTypeSurvey)"
              size="sm" variant="outline">
            <b-icon-printer variant="primary"></b-icon-printer>
          </b-button>

        </template>

      </t-table>

    </t-page-list>

  </t-page>
</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import pageChecklistMixin from "@/mixins/page/pageChecklistMixin";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import TypeChecklistStatusService from "@/services/modules/checklist/TypeChecklistStatus.service";
import ChecklistDialog from "@/views/modules/checklist/Checklist/ChecklistDialog";

export default {
  mixins: [pageDefaultMixin, pageListMixin, pageChecklistMixin],
  name: 'Checklist',
  components: {ChecklistDialog},
  data() {
    return {
      StatusChecklistType,
      enableGeneralFields: false,
      form: {
        enterpriseId: 0,
        environmentId: 0,
        inspectorId: 0,
        typeChecklistId: 0,
        checklistStatusId: 0,
        issueDate: "",
        statusChecklist: 0,
        enableSingleEnvironment: null,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeChecklistOptions: [],
      typeChecklistStatusOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      delete this.form.status

      this.breadcrumb = [
        //{text: 'Configurações', to: {name: 'production-setting'}},
      ]

    },
    async mountedContinued() {

      await TypeChecklistModelService.selectList("").then((list) => {
        this.typeChecklistOptions = list
      }).catch(error => this.responseError(error))

      await TypeChecklistStatusService.selectList("").then((list) => {
        this.typeChecklistStatusOptions = list
      }).catch(error => this.responseError(error))


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onChecklistDialog(itemInserted) {
      this.goPath('checklist/' + itemInserted.value)
    },


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

